import type { SfxWithEngagementDocument } from '@music-vine/setlist';

/**
 * Generate SFX page title from Typesense document
 * @param sfx - The SFX document from Typesense
 * @param variantName - Optional variant name suffix (e.g., "Short", "Long")
 */
export const getSfxPageTitleFromTypesense = (
  sfx: SfxWithEngagementDocument,
  variantName?: string
): string => {
  let pageTitle = sfx.name;

  if (variantName && variantName.trim() !== '') {
    pageTitle += ` (${variantName})`;
  }

  if (!sfx.is_premium) {
    pageTitle += ' free';
  }

  pageTitle += ' sound effect • Uppbeat';

  return pageTitle;
};

/**
 * Generate SFX page meta description from Typesense document
 * Uses the same rotation pattern as the legacy implementation
 */
export const getSfxPageDescFromTypesense = (
  sfx: SfxWithEngagementDocument
): string => {
  const { name, is_premium, sfx_variant_id } = sfx;
  const forFreeText = is_premium ? '' : 'for free ';
  const freeText = is_premium ? '' : 'free ';

  const descriptions = [
    `Uppbeat is the music and sound effects platform for creators. Download ${name} and thousands more ${freeText}royalty-free SFX from our highly curated library of sounds now.`,
    `Download thousands of royalty-free sound effects, including ${name} and many more on Uppbeat, the ${freeText}sound effects platform for YouTubers and creators.`,
    `Discover the best sound effects for creators on Uppbeat. ${name} is one of thousands of royalty-free sound effects available for you to download ${forFreeText}now.`,
    `Our ${name} sound effect is one of thousands you can download now ${forFreeText}on Uppbeat. Discover world-class music and royalty-free SFX for your content now.`,
    `Uppbeat is the royalty-free sound effects and music library for creators. Sign up for free and download our ${name} sound effect and thousands more ${forFreeText}on Uppbeat.`,
  ];

  // Use the variant ID to get a description
  // The description will be consistent for a given ID and evenly distributed
  const id = Number(sfx_variant_id) || 0;
  const index = id % descriptions.length;

  return descriptions[index] ?? descriptions[0];
};
